import { IProduct } from '@/retail/contexts/product/domain/IProduct'
import { IProductRepository } from '@/retail/contexts/product/domain/IProductRepository'

export class GetProductList {
  constructor(private readonly productRepository: IProductRepository) {}

  public async execute(): Promise<IProduct[]> {
    return this.productRepository.listProducts()
  }
}
